// written by damon bolesta @dbolesta
// last updated 04.25.2024

// this script will check if the user is in Europe and if so, it will redirect them to the European site
// on the second visit, it will show a popup asking if they want to be redirected
// if they decline, it will not show the popup for a week

fetch('https://ipapi.co/json/')
    .then((response) => response.json())
    .then((data) => {
        const userCountryCode = data.country_code;
        const targetCountries = [
            'PT',
            'BE',
            'ES',
            'FR',
            'GB',
            'DE',
            'IE',
            'IT',
            'NL',
        ];

        if (targetCountries.includes(userCountryCode)) {
            const now = new Date().getTime();
            const redirectToEUDeclinedTimestamp = localStorage.getItem(
                'redirectToEUDeclinedTimestamp'
            );
            const weekInMilliseconds = 7 * 24 * 60 * 60 * 1000;

            if (!localStorage.getItem('redirectedToEurope')) {
                localStorage.setItem('redirectedToEurope', 'true');
                window.location.href = 'https://kikkerlandeu.com';
            } else if (
                !redirectToEUDeclinedTimestamp ||
                now - redirectToEUDeclinedTimestamp > weekInMilliseconds
            ) {
                // Dynamically create the popup HTML
                createPopup();
            }
        }
    })
    .catch((error) => console.error('Error fetching user country:', error));

// <p>Hey! We notice you're in Europe! Would you like to be taken to the European version of the site?</p>
function createPopup() {
    const popupHTML = `
        <div id="euPopup" class="eu-popup">
            <div class="eu-popup-content">
                <img src="https://cdn.shopify.com/s/files/1/1140/3964/files/hey-u-in-eu.jpg?v=1738767687" />
                <button id="yesBtn">Take me to Kikkerland EU!</button>
                <button id="noBtn">No thanks!</button>
            </div>
        </div>
    `;
    document.body.insertAdjacentHTML('beforeend', popupHTML);

    const popup = document.getElementById('euPopup');
    popup.style.display = 'flex';

    document.getElementById('yesBtn').addEventListener('click', function () {
        window.location.href = 'https://kikkerlandeu.com';
    });

    document.getElementById('noBtn').addEventListener('click', function () {
        localStorage.setItem(
            'redirectToEUDeclinedTimestamp',
            new Date().getTime()
        );
        popup.style.display = 'none';
    });

    document
        .querySelector('.close-eu-popup')
        .addEventListener('click', function () {
            popup.style.display = 'none';
        });
}
